import React from 'react';
import CepField from '@catalogo/ui-americanas-mobile-cep-field';
import withNearStore from '@catalogo/service-americanas-product/src/hocs/near-store';
import { fmtStoreError } from '@catalogo/service-americanas-product/src/helpers/near-store';
import { Loading } from '@catalogo/ui-americanas-mobile-freight/src/components/loading';
import { Container } from './components/container';
import { Content } from './components/content';

export const NearStore = ({
  store,
  storeData,
  storeError,
  isLoading,
  showLoader,
  freightData,
  errorData,
  isInvalidCep,
  device,
}) => {
  if (showLoader) {
    return <Loading device={device} text="buscando loja mais próxima" />;
  }

  if ((storeError || !store) && !isInvalidCep) {
    const error = fmtStoreError(storeError, storeData);

    return (
      <Container device={device}>
        <CepField label="encontre a loja mais proxima" error={error} />
      </Container>
    );
  }

  return (
    <Content device={device} errorData={errorData} store={store} freight={freightData?.freight} isLoading={isLoading} />
  );
};

export default withNearStore(NearStore);
